<template lang="html">
  <div class="hackathon-projects"
  data-aos="fade-left"
  data-aos-easing="ease-out-quad"
  data-aos-duration="250">
  <div class="hackathons">
    <h1>Hackathon Projects</h1>
    <hr>
    <div class="projects">
      <div class="project-details">
        <div class="projects-detail">
          <a href="https://devpost.com/software/flatline" target="_blank">
            <img src="../assets/pastprojects/flatline.jpg" alt="">
          </a>
          <h2>QHacks 2018 - Flatline - ScotiaBank AI/Machine Learning Prize</h2>
          <p>Use case: The app can follow and analyze up to ~ ten students emotions and provide information in real time using our dashboard. </p>
        </div>
        <div class="projects-detail">
          <a href="https://devpost.com/software/pie-rb7znp" target="_blank">
            <img src="../assets/pastprojects/hackthenorth.jpg" alt="">
          </a>
          <h2>Hack the North 2018 - PIE - No Prize but a lot of fun and experience</h2>
          <p>Built on blockchain technology, Pie is your way of knowing how your money donated to charity is spent</p>
        </div>
        <div class="projects-detail">
          <a href="https://rbc-hack.netlify.com/" target="_blank">
            <img src="../assets/pastprojects/rbc-hacks.png" alt="">
          </a>
          <h2>RBC Next Generation Innovators 2017 - RBC Sprints - 3rd Place</h2>
          <p>RBCSprints is an initiative to encourage skills and career enhancement through experiential learning while tackling real business opportunities.</p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</div>

</template>

<script>
export default {
}
</script>

<style lang="scss">

.hackathon-projects {
  margin-bottom: 100px;
}

.project-details {
  text-align: center;
  display: grid;
  grid-template-columns: 50% 50%;

  .projects-detail {
    padding: 10px;
  }

  img {
    border-radius: 5px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
    border: none;
    width: 100%;
  }
}

@media only screen and (max-width: 900px) {
  .project-details {
      text-align: center;
      display: grid;
      grid-template-columns: 100%;
  }
}

</style>
